import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=647ddbd0&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage.css?vue&type=style&index=0&id=647ddbd0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ddbd0",
  null
  
)

export default component.exports